
import useNetlifyLogin from '#/useNetlifyLogin'

import { defineComponent, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { includes, last, split, o } from 'ramda'

export default defineComponent({
	name: 'UserStuff',

	setup () {
		const { hash } = useRoute()
		const { confirm, signup } = useNetlifyLogin()
		const hashParam = () => o(last, split('='))(hash) as string

		const isConfirm = computed<boolean>(() => includes('#recovery_token=')(hash))
		const isSignUp  = computed<boolean>(() => includes('#signup=')(hash))

		onMounted(async () => {
			if (isConfirm.value) {
				const load = await confirm(hashParam())
				console.log(load)
			}
			else if (isSignUp.value) {
				const load = await signup(hashParam(), 'HermesPoppar2020')
				console.log(load)
			}
		})
	}
})
